import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export class CommentsRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  getNewsComments(requestVO) {
    throw new Error('[CommentRepository#getNewsComments] must be implemented')
  }
}
